import { getCurrencyFromStorage, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, permissionPresets, request, services } from '@/utils'

const pathToAPI = getServicePathToAPI(services.settingsUser)

export const currency = {
  data() {
    return {
      currency: getCurrencyFromStorage()
    }
  },

  methods: {
    async getCurrency(ownerId) {
      if (ownerId) {
        if (this.checkPermissions(`advanced.${services.settingsUser}.get`, permissionPresets.resellerUp)) {
          try {
            const data = await request.get(joinURLPath(pathToAPI, ownerId, 'billings.currency'))
            if (data && data.result) {
              this.currency = data.result
            }
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      }
    }
  }
}
